module.exports = __webpack_public_path__ + "static/img/feature_01.bdc9ad7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/ares/secondAnniversary/3/feature_01.png
// module id = BuSS
// module chunks = 10